import { motion } from "framer-motion";
import { Check } from "lucide-react";

const reasons = [
  "We build custom strategies — no cookie-cutter plans",
  "We film, edit, post, and optimize — all in-house",
  "We build automations that save hours and bring leads",
  "We move fast, and we don't miss details",
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-choose-us-section"
      className="py-24 md:py-32 bg-dark"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/ohwln4uq_IMG_0129%20%281%29.jpg"
                alt="TAKEOFF team at work"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border-2 border-lime -z-10" />
          </motion.div>

          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2
              data-testid="why-choose-title"
              className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl uppercase text-white mb-8"
            >
              Why Brands Choose{" "}
              <span className="text-lime">TAKEOFF</span>
            </h2>

            <div className="space-y-5">
              {reasons.map((reason, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  data-testid={`reason-${index}`}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-lime flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-4 h-4 text-black" />
                  </div>
                  <p className="font-body text-white/80 text-base">{reason}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
